import curry from 'just-curry-it';
import createAction from './createAction';
export default (function (type, payloadCreator) {
  return curry(createAction(type, payloadCreator), payloadCreator.length);
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/createCurriedAction.js
// module id = tfEc
// module chunks = 0